export const tenants = ({ tenants }) => tenants



// WEBPACK FOOTER //
// ./src/store/getters/tenant.js